<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-05-26 11:34:22
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-31 17:00:23
-->
<template>
<div class="special-list">
    <Row>
        <Col :xs="24" :sm="24">
        <Form :inline="true">
            <FormItem>
                <Button @click="showDraw()" type="success" class="f-r">添加</Button>
            </FormItem>
        </Form>
        </Col>
    </Row>
	<Spin size="large"
          fix
          v-if="showLoading"
          class="totalLoad"></Spin>
    <!-- <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table> -->
	<table class="custom-table" v-if="tablelist && tablelist.length">
		<tr>
			<td class="custom-th"><span>id</span></td>
			<td class="custom-th" style="width: 100px;" v-for="(item,index) in tablelist[0].content" :key="index">{{ item.name }}</td>
		</tr>
		<tr class="custom-tr" v-for="(item,index) in tablelist" :key="index">
			<td class="custom-td">
				<div class="custom-td-con">{{ item.id }}</div>
			</td>
			<td class="custom-td" v-for="(sec,index) in item.content" :key="index">
				<div class="custom-td-con" v-if="sec.type == 0 || sec.type == 3">
					{{ sec.value }}
				</div>
				<div class="custom-td-con" v-if="sec.type == 1 && sec.value">
					<ListThumb :thumbList="sec.value"> </ListThumb>
				</div>
				<div class="custom-td-con" v-if="sec.type == 2 && sec.value">
					<ListJieshao :jieshao="sec.value"></ListJieshao>
				</div>
				<div class="custom-td-con" v-if="sec.type == 4 && sec.value">
					<Button type="primary">
						<a :href="sec.value" style="color:#ffffff;">附件</a>
					</Button>
				</div>
			</td>
		</tr>
	</table>
    <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title" v-model="showDrawStatus" width="1000" :mask-closable="false" :styles="styles">
        <ListsAdd ref="addlist" @uplist="onUplist($event)"></ListsAdd>
    </Drawer>
</div>
</template>

<script>
import ListJieshao from './listscomponents/jieshao.vue'
import ListThumb from './listscomponents/thumbs.vue'
import ListsAdd from './ListsAdd.vue'
export default {
    components: {
        ListJieshao,
        ListThumb,
        ListsAdd
    },
    data() {
        return {
            columns: [],
            tablelist: [],
            dataloading: false,
            pages: {
                page: 1,
                size: 10,
                total: 0
            },
            title: "添加",
            showDrawStatus: false,
            styles: {
                height: "calc(100% - 55px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static"
            },
			showLoading: false
        }
    },
    created() {
		this.getList();
    },
    methods: {
        /**
         * @name: 添加
         * @return {*}
         * @desc: 
         */
        showDraw() {
            this.showDrawStatus = true;
            this.$nextTick(function () {
                this.$refs.addlist.initFun();
            })
        },
        /**
         * @name: 分页
         * @return {*}
         * @desc: 
         */		
        changePage() {
			this.pages.page = this.$refs["listPage"].currentPage;
			this.getList();
        },
        /**
         * @name: 获取列表
         * @return {*}
         * @desc: 
         */
        getList() {
            let params = {
                page: this.pages.page,
                size: this.pages.size
            };
			this.showLoading = true;
            this.$api.lists.list(params).then(res => {
				this.showLoading = false;
                this.tablelist = res.result.list;
				this.pages.total = res.result.total;
            });
        },
        /**
         * @name: 接收组件传值
         * @param {*} val
         * @return {*}
         * @desc: 
         */
        onUplist(val) {
            this.showDrawStatus = false;
            this.getList();
        }
    }
}
</script>
<style scoped>
	.custom-table{
		width: 100%;
		border-collapse:collapse;
		/* border: 1px solid #e8eaec; */
	}
	.custom-th{
		height: 48px;
		background-color: #f8f8f9;
		color: #515a6e;
		font-size: 12px;
		width: 100px;
		padding-left: 18px;
    	padding-right: 18px;
		font-weight: bold;
	}
	.custom-td-con{
		padding: 18px;
	}
</style>